import React from "react";
import TeakSpiceStore from "./TeakSpiceStore";

function App() {
  return <TeakSpiceStore />;
}

export default App;
